<template>
  <div class="main">
    <div class="title">
      <div class="name">专家评价</div>
      <div class="btn" @click="$router.back()">
        <img src="../../../assets/images/back.png" alt="">
        返回
      </div>
    </div>
    <div class="list-box">
      <el-table
          :data="tableData"
          v-loading="loading"
          border
          :header-cell-style="{
            'text-align':'center',
            'height':'58px',
            'background-color':'#dae0e6',
            'color':'#333'}"
          :cell-style="{'text-align':'center'}"
          style="width: 100%;border-radius: 10px;">
        <el-table-column
            type="index"
            label="序号"
            width="50">
        </el-table-column>
        <el-table-column
            prop="name"
            label="预约人"
            width="110">
<!--          <div slot="header">-->
<!--            <div class="flex justify-center align-center pointer" @click="sort('name')">-->
<!--              <div>专家姓名</div>-->
<!--              <div class="flex flex-direction margin-left-xs">-->
<!--                <i class="el-icon-caret-top" :class="{iconactive : nameSort == 1}"></i>-->
<!--                <i class="el-icon-caret-bottom" :class="{iconactive : nameSort == 2}"></i>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </el-table-column>
        <el-table-column
          prop="score"
          label="评价分数"
          width="90">
        </el-table-column>
        <el-table-column
          prop="evaluate"
            label="评价内容">
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="评价时间"
          width="200">
        </el-table-column>
      </el-table>
      <div class="page-box">
        <el-pagination
          :current-page.sync="page"
          :page-size="limit"
          :total="total"
          background
          class="page-all margin-top self-end"
          layout="prev, pager, next"
          @current-change="list">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {expertDel, expertInternalYuyueEvluateList} from "@/api/index";
import {baseURL, urlStr} from "@/config";
export default {
  name: "detail",
  data() {
    return {
      loading:false,
      urlStr: urlStr,
      baseURL:baseURL,
      nameSort:2, // 1 正序 2 倒序
      numSort:'', // 1 正序 2 倒序
      id:'',
      tableData: [],
      page:1,
      limit:10,
      total:0,
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {},
  created() {
    this.id = this.$route.query.id
    this.$emit("setActive", {
      active: 1,
      act: 2,
      name: '专家管理 > 专家信息 > 专家评价'
    })
    this.list()
  },
  methods: {

    sort(){
      this.nameSort = this.nameSort == 1 ? 2 : (this.nameSort == 2 ? '' : 1)
      this.list()
    },

    handleDelete(id) {
      this.$confirm('此操作将删除该数据，是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.expertDel(id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    // 删除专家
    async expertDel(id){
      let _res = await expertDel(
          this.user.mid,
          id
      );
      if(_res.status === 200){
        this.$message.success(_res.msg);
        this.list()
      }else {
        this.$message.error(_res.msg);
      }
    },

    // 获取列表
    async list() {
      this.loading = true
      let _res = await expertInternalYuyueEvluateList(
          this.user.mid,this.id,
          this.page,this.limit
      );
      this.loading = false
      if (_res.status === 200) {
        this.tableData = _res.data.list
        this.total = _res.total_number
      } else {
        this.$message.error(_res.msg)
      }
    },
  },
  watch: {

  },
  filters: {}
}
</script>

<style scoped lang="scss">
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 8px 15px 8px;
  .name {
    font-size: 20px;
    color: #ffffff;
    font-weight: bold;
  }
  .btn {
    width: 100px;
    height: 40px;
    background-color: #ffffff;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    letter-spacing: 1px;
    color: #0a2240;
    cursor: pointer;
    img {
      width: 14px;
      height: 12px;
      margin-right: 2px;
    }
  }
}
.el-icon-caret-top {
  color: #999999;
}
.el-icon-caret-bottom {
  color: #999999;
}
.iconactive {
  color: #000000;
}
.show{
  width: 70px;
  height: 30px;
  background-color: #ff9600;
  border: 1px solid #ff9600;
  line-height: 28px;
  padding: 0;
  border-radius: 15px;
  color: #ffffff;
  margin-top: 5px;
}
.hide{
  width: 70px;
  height: 30px;
  background-color: #dae0e6;
  border: 1px solid #dae0e6;
  line-height: 28px;
  padding: 0;
  border-radius: 15px;
  color: #ffffff;
  margin-top: 5px;
}
.del {
  width: 55px;
  height: 30px;
  border-radius: 15px;
  border: solid 1px #0a2240;
  line-height: 28px;
  padding: 0;
  color: #0a2240;
  margin-left: 0;
  margin-top: 5px;
}
.edit {
  width: 55px;
  height: 30px;
  background-color: #0a2240;
  line-height: 28px;
  padding: 0;
  border-radius: 15px;
  margin-top: 5px;
  margin-left: 0;
}
.main {
  display: flex;
  flex-direction: column;
  .title {
    padding: 5px 8px 15px 8px;
    .name {
      font-size: 20px;
      color: #ffffff;
      font-weight: bold;
    }
  }

  .tab {
    width: 100%;
    display: flex;
    justify-content: space-between;
    background-color: #ffffff;
    padding: 10px;
    border-radius: 10px;
    span {
      width: 236px;
      height: 50px;
      background-color: #f3f7fb;
      border-radius: 10px;
      border: solid 1px #dae0e6;
      font-size: 18px;
      color: #0a2240;
      text-align: center;
      line-height: 48px;
      cursor: pointer;
      a {
        font-size: 18px;
        color: #0a2240;
      }
      &:hover {
        background-color: #ff9600;
        border: solid 1px #ff9600;
        color: #ffffff;
        a {
          color: #ffffff;
        }
      }
    }
  }

  .list-box {
    width: 100%;
    background-color: #ffffff;
    border-radius: 10px;
    padding: 15px;
    flex: 1;

    .search-box {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      .select-box {
        width: 162px;
      }
      .chongz {
        width: 99px;
        height: 40px;
        background-color: #0a2240;
        border-radius: 5px;
        font-size: 16px;
        color: #ffffff;
        cursor: pointer;
        text-align: center;
        line-height: 40px;
      }
      .input-box {
        flex: 1;
        width: 0;
        margin: 0 15px;
        display: flex;
        height: 40px;
        overflow: hidden;
        justify-content: space-between;
        border-radius: 5px;

        > div {
          width: 100px;
          height: 40px;
          background-color: #0a2240;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          span {
            font-size: 16px;
            color: #ffffff;
          }
          i {
            margin-right: 4px;
            color: #ffffff;
            font-size: 18px;
          }
        }
      }
    }

  }
}
</style>


